<div class="clug-list-card">
  <div class="card-loader" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="card-header">
    <span class="card-header-count">{{totalCount}} Job(s)</span>
    <div class="input-group">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search jobs..." [(ngModel)]="jobSearch" (keyup)="searchJob()">
    </div>
  </div>

  <div class="table-responsive">
    <table matSort (matSortChange)="sortData($event)" class="table">
      <thead>
        <tr>
          <th mat-sort-header="title" scope="col">Name</th>
          <th mat-sort-header="title" scope="col">Client</th>
          <th mat-sort-header="title" scope="col">Candidate Name</th>
          <th mat-sort-header="start_date" scope="col">Start Date</th>
          <th mat-sort-header="end_date" scope="col">End Date</th>
          <th mat-sort-header="status" scope="col">Status</th>
          <th class="actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of allJobs" class="dataColumn">
          <td (click)="openAuditTrail(job)">
            <div class="cell-with-icon" matTooltip="{{job.description ?? '--'}}" [matTooltipPosition]="'below'">
              <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
              <span class="cell-text">{{job.title}}</span>
            </div>
          </td>
          <td matTooltip="{{job.location ?? '--'}}" [matTooltipPosition]="'below'">{{job.client ?? '--'}}</td>
          <td>{{job.contractors.join(', ') ?? '--'}}</td>
          <td>{{dataSharedService.tranformDate(job.start_date)}}</td>
          <td>{{dataSharedService.tranformDate(job.end_date)}}</td>
          <td>
            <span class="pill pending" *ngIf="job.status === 2">Request Sent</span>
            <span class="pill submitted" *ngIf="job.status === 3">Details Submitted</span>
            <span class="pill rejected" *ngIf="job.status === 4">Rejected</span>
            <span class="pill rejected" *ngIf="job.status === 5">Permanent Rejected</span>
            <span class="pill submitted" *ngIf="job.status === 6">Details Resubmitted</span>
          </td>
          <td class="td-actions">
            <div class="row-actions">
              <button type="button" class="icon-btn-sm info" matTooltip="Edit" [matTooltipPosition]="'left'" (click)="onEdit(job)">
                <i class="bi bi-pencil"></i>
              </button>
              <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY && job.contract == null && job.status !== 4" class="icon-btn-sm warning" matTooltip="Send Contract" [matTooltipPosition]="'left'" (click)="onEdit(job, true)">
                <i class="bi bi-c-square"></i>
              </button>
              <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY || job.status !== 5" class="icon-btn-sm reject" matTooltip="Deactivate job" [matTooltipPosition]="'left'" (click)="inactivateJob(job.uuid)">
                <i class="bi bi-lock"></i>
              </button>
              <button type="button" *ngIf="(user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.SUPER_ADMIN) && (job.status === 3 || job.status === 4 || job.status === 5 || job.status === 6)" class="icon-btn-sm" matTooltip="View Onboarding Form Details Submitted By Candidate" [matTooltipPosition]="'left'" (click)="viewOnBoardingFormDetails(job)">
                <i class="bi bi-eye"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-pagination" *ngIf="totalCount">
    <span class="pagination-summary">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} requests
    </span>
    <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
  </div>
</div>
